import { useEffect, useState } from "react";
import { useLanguageContext } from "../../../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../../../Context/GlobalSpinnerContext";
import {
  DataGridPro,
  useGridApiRef,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid-pro";
import tabsStore from "../../../../Stores/TabsStore";
import tabsConstants from "../../../../Constants/TabsConstants";
import tabsActions from "../../../../Actions/TabsActions";
import {
  LocalizationDataGridConst,
  tableFilterProperty,
} from "../../../ReusableComponent/DataGrid/LocalizationDataGrid";
import { GridToolbarTableButton } from "../../../ReusableComponent/GridToolBar";
import { Tooltip, Stack, Typography, Paper, Box } from "@mui/material";
import OrderReportGenerator from "./orderReportGenerate";
import OrderImageButton from "./orderImageButton";
import Lightbox from "react-awesome-lightbox";
export default function OrderDetails(props) {
  const { items } = props;
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [expandedRowData, setExpandedRowData] = useState({});
  const [showLightBox, setShowLightBox] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const apiRef = useGridApiRef();
  const columnHeader = [
    {
      field: "scheduleAt",
      headerName: localization.scheduleAt,

      flex: 1,
    },
    { field: "endDate", headerName: localization.pruefdatumLabel, flex: 1 },
    { field: "title", headerName: localization.checklist, flex: 1 },
    { field: "pruefer", headerName: localization.prueferLabel, flex: 1 },
    { field: "turnus", headerName: localization.turnusLabel, flex: 1 },
    { field: "frequency", headerName: localization.zyklusLabel, flex: 1 },
    {
      field: "nio",
      headerName: localization.inspectionStatus,
      type: "singleSelect",
      valueOptions: () => [
        { value: localization.nio, label: localization.nio },
        { value: localization.io, label: localization.io },
      ],
      renderCell: (params) => {
        const backgroundColor = params["row"]["nio"] ? "#FBE3E3" : "#E3FBE3";
        const textColor = params["row"]["nio"] ? "#A00" : "#0A470A";

        const nioText = params["row"]["nio"]
          ? localization.nio
          : localization.io;
        return (
          <Tooltip>
            <div
              style={{
                backgroundColor: backgroundColor,
                padding: "0 6px 0 6px",
                display: "flex",
                alignItems: "center",
                borderRadius: "15px",
                color: textColor,
              }}
            >
              <span>{nioText}</span>
            </div>
          </Tooltip>
        );
      },
      valueGetter: (params) => {
        if (params.value) {
          return localization.nio;
        } else {
          return localization.io;
        }
      },
      flex: 1,
    },
  ];

  const nestedGridColumn = [
    { field: "chapter", headerName: localization.chapter, flex: 1 },
    { field: "block", headerName: localization.block, flex: 1 },
    { field: "pos", headerName: localization.pos, flex: 1 },
    { field: "frage", headerName: localization.frage, flex: 1 },
    { field: "antwort", headerName: localization.antwort, flex: 1 },
    {
      field: "images",
      headerName: localization.image || "Image",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const images = params.row?.images || [];
        if (!images || images.length === 0) {
          return <span>-</span>;
        }
        return (
          <Stack
            direction="row"
            spacing={1}
            sx={{ height: "100%", alignItems: "center" }}
          >
            {images.map((image, index) => (
              <Box
                component="img"
                src={`data:image/jpg;base64,${image.documentAsString}`}
                alt={image.name || `Image ${index + 1}`}
                sx={{
                  height: "50px",
                  width: "50px",
                  objectFit: "cover",
                  borderRadius: "4px",
                  cursor: "pointer",
                  border: "1px solid #ccc",
                  marginY: "5px",
                }}
                className="thumbnailPreview"
                onClick={(e) => {
                  e.stopPropagation();
                  // Optional: Open full-size image or lightbox here
                  setShowLightBox(true);
                  setSelectedImage(
                    `data:image/jpg;base64,${image.documentAsString}`,
                  );
                }}
              />
            ))}
          </Stack>
        );
      },
    },
  ];
  const handleSelected = (row, isExpand) => {
    if (expandedRowId === row.id) {
      setExpandedRowId(null);
      apiRef.current.toggleDetailPanel(row.id);
    } else {
      setGlobalSpinner(true);
      setExpandedRowId(row.id);
      tabsActions.getAuftragDetailsByAuftrageId(row.id);
      if (!isExpand) {
        apiRef.current.toggleDetailPanel(row.id);
      }
    }
  };

  const handleDetailPanelExpandChange = (newExpandedRowIds) => {
    if (newExpandedRowIds.length > 0) {
      const newlyExpandedRowId =
        newExpandedRowIds[newExpandedRowIds.length - 1];
      const expandedRow = items.find((row) => row.id === newlyExpandedRowId);
      if (expandedRow) {
        handleSelected(expandedRow, true); // Pass `true` to avoid toggling again
      }
    } else {
      setExpandedRowId(null);
    }
  };

  useEffect(() => {
    function getOrderDetailsByIDSuccess() {
      const res = tabsStore.getResult();
      if (res) {
        let _temp = [];
        res.checklistChapterModels.forEach((chapterIndex, chapterNum) => {
          chapterIndex.checklistBlockModels.forEach((block, blockNum) => {
            block.answers.forEach((answer, answerIndex) => {
              _temp.push({
                ...answer,
                chapter: chapterIndex.title,
                block: block.title,
                id: `${chapterNum}-${blockNum}-${answerIndex}`,
              });
            });
          });
        });
        _temp.feedBack = res.feedBack;

        setExpandedRowData((prevState) => ({
          [expandedRowId]: _temp,
        }));
      }
      setGlobalSpinner(false);
    }
    function getOrderDetailsByIDFailure() {
      const res = tabsStore.getOrderStatusResult();

      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_AUFTRAGSDETAILBYID_SUCCESS,
      getOrderDetailsByIDSuccess,
    );
    tabsStore.addChangeListener(
      tabsConstants.GET_AUFTRAGSDETAILBYID_FAILURE,
      getOrderDetailsByIDFailure,
    );
    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_AUFTRAGSDETAILBYID_SUCCESS,
        getOrderDetailsByIDSuccess,
      );
      tabsStore.removeChangeListener(
        tabsConstants.GET_AUFTRAGSDETAILBYID_FAILURE,
        getOrderDetailsByIDFailure,
      );
    };
  }, [expandedRowId]);

  const DetailPanelContent = (params) => {
    const data = expandedRowData[params.id];
    return (
      <Stack className="orderInnerDatagrid" direction="column">
        <Paper sx={{ border: "none" }}>
          <Typography variant="h6">{localization.pruefungsdetails}</Typography>
          <Stack direction="column" spacing={1} sx={{ height: 1 }}>
            <Box id="nestedOrderDetails">
              <DataGridPro
                density="compact"
                columns={nestedGridColumn}
                rows={data ? data : []}
                slots={{
                  toolbar: () => (
                    <GridToolbarInnerTableButton selectedItemId={params.id} />
                  ),
                }}
                sx={{ flex: 1 }}
                pagination
                localeText={{
                  ...LocalizationDataGridConst(localization),
                }}
                slotProps={{
                  pagination: {
                    labelRowsPerPage: localization.rowsPerPage,
                  },
                  filterPanel: { ...tableFilterProperty },
                }}
              />
            </Box>{" "}
            {data && (
              <Typography variant="h6">
                {localization.orderTableFeedback + ":"}
                {data["feedBack"] === "" || data["feedBack"] === null
                  ? "No feedback"
                  : data["feedBack"]}
              </Typography>
            )}
          </Stack>
        </Paper>
        <Paper sx={{ flex: 1, mx: "auto", width: "90%", p: 1, border: "none" }}>
          {<OrderImageButton anlageid={""} item={params.id} />}
        </Paper>
      </Stack>
    );
  };

  return (
    <div id="dataGrid">
      <DataGridPro
        id="dataGridProMainGrid"
        apiRef={apiRef}
        rows={items}
        columns={columnHeader}
        density="compact"
        onRowClick={(params) => handleSelected(params.row)}
        onDetailPanelExpandedRowIdsChange={handleDetailPanelExpandChange}
        detailPanelExpandedRowIds={expandedRowId ? [expandedRowId] : []}
        localeText={{
          ...LocalizationDataGridConst(localization),
        }}
        slots={{ toolbar: GridToolbarTableButton }}
        slotProps={{
          pagination: {
            labelRowsPerPage: localization.rowsPerPage,
          },
          filterPanel: { ...tableFilterProperty },
        }}
        getDetailPanelContent={DetailPanelContent}
        pagination
        getDetailPanelHeight={({ row }) => "auto"}
      />
      {showLightBox && (
        <Lightbox
          allowReset={false}
          onClose={() => setShowLightBox(false)}
          image={selectedImage}
        ></Lightbox>
      )}
    </div>
  );
}
function GridToolbarInnerTableButton({ selectedItemId }) {
  return (
    <GridToolbarContainer id="mainGridButton">
      <div>
        {<GridToolbarColumnsButton />}
        {<GridToolbarFilterButton />}
        {<GridToolbarDensitySelector />}
        {<OrderReportGenerator selectedItemId={selectedItemId} />}
      </div>
    </GridToolbarContainer>
  );
}
